// Components==============
import { faSearchMinus, faSearchPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import { HomeContext } from 'screens/Home/Home';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import './ZoomButton.module.scss';
// =========================

export default function ZoomButton() {
    const { handleZoom } = useContext(HomeContext);
    const {
        welcomeSequence,
        setWelcomeY,
        setWelcomeRight,
        setWelcomeX,
        setWelcomeLeft,
    } = useContext(HomeContext);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (welcomeSequence === 'zoomIn') {
            setWelcomeY(`${ref?.current?.offsetTop!}px`);
            // Tweaks to position welcomesequence for zoom left
            setWelcomeRight('');
            setWelcomeX('0');
            setWelcomeLeft('100px');
        }
        if (welcomeSequence === 'zoomOut') {
            setWelcomeY(`${ref?.current?.offsetTop! + 65}px`);
        }
    }, [welcomeSequence]);

    function zoomIn(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        handleZoom({ event, direction: 1 });
    }

    function zoomOut(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        handleZoom({ event, direction: -1 });
    }

    return (
        <div styleName="wrapper" ref={ref}>
            <motion.button
                animate={welcomeSequence === 'zoomIn' ? pulse : initialPulse}
                initial={initialPulse}
                styleName="in"
                onClick={zoomIn}
                type="button"
            >
                <FontAwesomeIcon icon={faSearchPlus} />
            </motion.button>
            <motion.button
                animate={welcomeSequence === 'zoomOut' ? pulse : initialPulse}
                initial={initialPulse}
                styleName="out"
                onClick={zoomOut}
                type="button"
            >
                <FontAwesomeIcon icon={faSearchMinus} />
            </motion.button>
        </div>
    );
}
